import { render } from "./PanelAdminArticleCreate.vue?vue&type=template&id=6b90a97b&scoped=true&ts=true"
import script from "./PanelAdminArticleCreate.vue?vue&type=script&lang=ts"
export * from "./PanelAdminArticleCreate.vue?vue&type=script&lang=ts"

import "./PanelAdminArticleCreate.vue?vue&type=style&index=0&id=6b90a97b&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b90a97b"]])

export default __exports__